import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action } from 'mobx';
import { Dropdown } from './Dropdown';
import { Flasher } from './Flasher';
import { Messenger } from '../../view/Flasher/component';
import { getIn } from '../../utils';

import translateBase from '../../translate';
let translate = translateBase.bindComponent('siteHeader');

@inject(stores => ({
  navigation: stores.app.navigation,
  flasher: stores.app.flasher,
  loginForm: stores.app.loginForm,
  authentication: stores.app.authentication,
}))
@observer
export class LoggedOutDropdown extends React.Component {

  constructor() {
    super();
    this.state = {
      iFrameError: false
    }
  }

  componentDidMount() {
    window.addEventListener("message", this.handleMessagePost);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessagePost);
  }

  @action.bound handleMessagePost(ev) {
    if (ev.data && ev.data === 'SIGNED_IN') {
      this.props.authentication.login();
    }
  }

  onLoadIframe = () => {
    var iFrame = document.getElementById("login-iframe-dd");
    if (iFrame) {
      var hasError = iFrame.contentWindow.document.querySelector(".alert-danger") != null;
      this.setState({
        iFrameError: hasError
      });
    }
  }

  render() {
    const { flasher, loginForm, authentication, navigation } = this.props;
    return (
      <Dropdown>{({ ref, isOpen, onOpen, onClose }) => <Observer>{() =>
        <div ref={ref} className="column-3 offset-6 login-container">
          <a className="login small" onClick={onOpen}>
            {translate("login", "Anmelden")} <i className="fa fa-heart" aria-hidden="true"></i>
          </a>
          {
            <div className={"login-overlay-container" + (isOpen ? ' active' : '') + (this.state.iFrameError ? " iframe-error" : "")}>
              <div className="row">
                <iframe src="/auth" height="100%" width="100%" frameBorder="0" scrolling="no" id="login-iframe-dd" onLoad={this.onLoadIframe}></iframe>
              </div>
              <div className="row secondary small">
                <a onClick={navigation.goUserRegistration1}>{translate("newRegistration", "Neu registrieren")}</a>
                <a onClick={navigation.goPasswordRecovery1}>{translate("passwordRecovery", "Passwort vergessen?")}</a>
              </div>
            </div>
          }
        </div>
      }</Observer>}</Dropdown>
    )
  }
}

@inject(stores => ({
  flasher: stores.app.flasher,
  navigation: stores.app.navigation,
  loginForm: stores.app.loginForm,
  authentication: stores.app.authentication,
}))
@observer
export class LoggedInDropdown extends React.Component {
  render() {
    const { authentication, flasher, navigation } = this.props;
    return (
      <Dropdown>{({ ref, isOpen, onOpen, onClose }) => <Observer>{() =>
        <div ref={ref} className="column-6 offset-3 login-container">
          <a className="login small" onClick={onOpen}>
            {authentication.userName} <i className="fa fa-heart" aria-hidden="true"></i>
          </a>
          <div className={"login-overlay-container" + (isOpen ? ' active' : '')}>
            <div className="row profile-dropdown">
              <div className="profile-icon">
                <i className="fa fa-user-circle" aria-hidden="true"></i>
              </div>
              <div className="profile-infos">
                <a onClick={navigation.goUserProfile}><div className="profile-name">{authentication.userName}</div></a>
                {/*<a className="small" onClick={navigation.goUserProfile}>Letzte Buchung</a>*/}
              </div>
            </div>
            <div className="row secondary loggedin small">
              {/*<a className="open-bills negative">Offene Rechnungen <span>CHF 975.00</span></a>
                    <div className="open-bills positive">Keine offene Rechnungen <span><i className="fa fa-check" aria-hidden="true"></i></span></div>*/}
              <a onClick={navigation.goUserProfile}>{translate("userProfile", "Profil Besuchen")}</a>
              <a onClick={navigation.goRecentBookings}>{translate("userBookings", "Meine Buchungen")}</a>
              <a className="logout" onClick={authentication.logout}>{translate("performLogout", "Abmelden")}</a>
            </div>
          </div>
        </div>
      }</Observer>}</Dropdown>
    )
  }
}

function logoImgSrc() {
  return getIn(window, ['ict', 'wyby', 'orgLogo']);
}

@inject(stores => ({
  navigation: stores.app.navigation,
  loginForm: stores.app.loginForm,
  authentication: stores.app.authentication,
}))
@observer
export class SiteHeader extends React.Component {
  render() {
    const { authentication } = this.props;
    return (
      <header className="header-container">
        <div className="wrapper">
          <div className="row">
            <div className="column-3">
              <div className="logo-container">
                <a href="#/home"><img src={logoImgSrc()} /></a>
              </div>
            </div>

            {authentication.loggedIn ?
              <LoggedInDropdown />
              :
              <LoggedOutDropdown />
            }
          </div>
        </div>


      </header>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/component/SiteHeader.js